import * as React from "react"

import cs from "classnames"
import { Tooltip } from "@mui/material"

import styles from "./ToolbarPlugin.module.scss"

type Option<T> = {
  value: T
  tooltipText: string
  icon: React.ReactNode
}

interface Props<T> {
  options: readonly Option<T>[]
  selectedOptions?: T[]

  handleOptionSelected: (value: T) => () => void
}

export const OptionSet = <T extends string>({ options, selectedOptions = [], handleOptionSelected }: Props<T>) => {
  return (
    <>
      {options.map(({ value, tooltipText, icon }) => (
        <Tooltip title={tooltipText} key={value} PopperProps={{ disablePortal: true }}>
          <button
            tabIndex={-1}
            onClick={handleOptionSelected(value)}
            className={cs(styles.toolbarButton, { [styles.active]: selectedOptions.includes(value) })}
            type="button"
          >
            {icon}
          </button>
        </Tooltip>
      ))}
    </>
  )
}
